import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyPersonalInfoModal from "./editProfileModals/EditMyPersonalInfoModal";

function MyPersonalInfo(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);
    var { profile } = props.store
    var { personalInfo } = profile
    return (
        <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>Personal Information</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                        <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        <EditMyPersonalInfoModal modal={newPlanModal} toggle={toggleNewPlanModal} personalInfo={personalInfo} />
                    </ul>                    
                </div>                
            </div> 
            <Collapse isOpen={!collapse}>            
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                 {personalInfo.gender ? <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Gender</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.gender}</div>                    
                    </div>
                </div>: null}
                  
                {personalInfo.languages && personalInfo.languages.length > 0 ? <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Languages Known</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.languages.map((o, i) => i == personalInfo.languages.length - 1 ? o : o + ", ")}</div>                    
                    </div>
                </div>:null }                 
                {personalInfo.visa ? <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Valid Visa</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.visa}</div>
                    </div>
                </div>: null} 
                {personalInfo.status ? <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Marital Status</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.status}</div>                    
                    </div>
                </div>: null}
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Reallocate State</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.stateReallocate ? "Yes" : "No"}</div>                    
                    </div>
                </div>  
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Reallocate Country</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.countryReallocate ? "Yes" : "No"}</div>                    
                    </div>
                </div>  
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Work From Home</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">{personalInfo.workFromHome ? "Available" : "Not Available"}</div>                    
                    </div>
                </div>
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default MyPersonalInfo